var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"session-type-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.sessionTypes,"preselected-value":_vm.sessionType,"default-value":_vm.sessionTypeDefaultValue},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }